'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var withKeyshape = function withKeyshape(settings, ComponentToWrap) {
  var withKeyshapeClass = function (_Component) {
    _inherits(withKeyshapeClass, _Component);

    function withKeyshapeClass(props) {
      _classCallCheck(this, withKeyshapeClass);

      var _this = _possibleConstructorReturn(this, (withKeyshapeClass.__proto__ || Object.getPrototypeOf(withKeyshapeClass)).call(this, props));

      _this.settings = settings; //this.jsId = jsId;      

      return _this;
    }

    _createClass(withKeyshapeClass, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (!window[this.settings.jsId]) {
          try {
            Promise.resolve().then(function () {
              var ret;

              try {
                ret = require('scripts/' + _this2.settings.animationScriptUrl);
              } catch (e) {
                console.log(e);
              }

              return ret; //return require('scripts/' + _this2.settings.animationScriptUrl);
            }).then(function (data) {
              var ksObj = window[_this2.settings.jsId];

              if (ksObj && ksObj.playAnimation) {
                ksObj.playAnimation(ksObj);
              }
            }).catch(function (error) {
              console.log(error);
            });
          } catch (e) {
            debugger;
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ComponentToWrap, _extends({}, this.props, this.state));
      }
    }]);

    return withKeyshapeClass;
  }(_react.Component);

  return withKeyshapeClass;
};

exports.default = withKeyshape;
/*
  var ret;
  try{
    ret = require('scripts/' + _this2.settings.animationScriptUrl)
  }catch(e){
    console.log(e);
  }
  return ret;
*/